const householdLivingSituation = [
  { label: 'zur Miete', value: 'RENTING' },
  { label: 'mietfrei', value: 'RENTFREE' },
  { label: 'bei den Eltern', value: 'PARENTS' },
  { label: 'im Wohneigentum', value: 'PROPERTY' }
]

export default householdLivingSituation
